/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.16 banknot.glb --transform 
Files: banknot.glb [13.78MB] > H:\objects\banknot-transformed.glb [104.3KB] (99%)
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export function Banknot(props) {
  const { nodes, materials } = useGLTF('3dmodels/banknot-transformed.glb')
  return (
    <group {...props} dispose={null}>
      <group scale={[2.622, 0.037, 1]}>
        <mesh geometry={nodes.Cube_1.geometry} material={materials.Material} />
        <mesh geometry={nodes.Cube_2.geometry} material={materials['Material.001']} />
      </group>
    </group>
  )
}

useGLTF.preload('3dmodels/banknot-transformed.glb')
